var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [!_vm.showEdit ? _c("div", [_c("el-button", {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      type: "success"
    },
    on: {
      click: function click($event) {
        return _vm.handleAdd();
      }
    }
  }, [_vm._v("添加表单信息 ")])], 1) : _vm._e(), !_vm.showEdit ? _c("div", [_c("el-table", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      data: _vm.tableData,
      border: ""
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "formId",
      label: "ID"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "title",
      label: "表单标题"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "表单状态"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(" " + _vm._s(_vm.statusOptions[scope.row.status]) + " ")];
      }
    }], null, false, 2263381867)
  }), _c("el-table-column", {
    attrs: {
      prop: "createdAt",
      label: "创建时间"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "操作",
      width: "280"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-button", {
          on: {
            click: function click($event) {
              return _vm.handleCheck(scope.row.formId);
            }
          }
        }, [_vm._v("查看")]), _c("el-button", {
          attrs: {
            type: "primary"
          },
          on: {
            click: function click($event) {
              return _vm.handleEdit(scope.row.formId);
            }
          }
        }, [_vm._v("编辑")])];
      }
    }], null, false, 1116000153)
  })], 1), _c("el-pagination", {
    style: {
      float: "right",
      padding: "20px"
    },
    attrs: {
      "current-page": _vm.page,
      "page-size": _vm.pageSize,
      "page-sizes": [5, 30, 50, 100, 500],
      total: _vm.total,
      layout: "total, sizes, prev, pager, next, jumper"
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange
    }
  })], 1) : _vm._e(), _vm.showEdit ? _c("div", [_c("el-page-header", {
    attrs: {
      content: _vm.form_id == 0 ? "新增表单" : "修改表单"
    },
    on: {
      back: function back($event) {
        _vm.showEdit = false;
      }
    }
  }), _c("edit", {
    attrs: {
      id: _vm.form_id
    },
    on: {
      backFather: _vm.backFather
    }
  })], 1) : _vm._e(), _vm.showCheck ? _c("div", [_c("el-dialog", {
    attrs: {
      title: "查看详细信息",
      visible: _vm.showCheck,
      width: "60%",
      center: ""
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.showCheck = $event;
      }
    }
  }, [_c("check-info", {
    attrs: {
      ID: _vm.checkID
    }
  })], 1)], 1) : _vm._e()]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };